import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Github, Linkedin, ArrowUpRight } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { translations } from '../translations/translations';
import SectionWrapper, { SectionHeader } from '../components/SectionWrapper';
import { fadeUp } from '../motion/presets';
import '../styles/Contact.css';

export default function Contact() {
  const { language } = useAppContext();
  const t = translations[language];

  return (
    <SectionWrapper id="contact" className="contact">
      <SectionHeader label={t.contact.label} title={t.contact.title} />

      <motion.div className="contact__content" variants={fadeUp}>
        <p className="contact__subtitle">{t.contact.subtitle}</p>

        <a
          href="mailto:mert.ozkaya@outlook.com.tr"
          className="contact__email"
        >
          mert.ozkaya@outlook.com.tr
          <ArrowUpRight size={18} />
        </a>

        <div className="contact__social">
          <a
            href="https://github.com/Mertozkaya21"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__social-link"
            aria-label="GitHub"
          >
            <Github size={20} />
          </a>
          <a
            href="https://www.linkedin.com/in/mertozkaya1"
            target="_blank"
            rel="noopener noreferrer"
            className="contact__social-link"
            aria-label="LinkedIn"
          >
            <Linkedin size={20} />
          </a>
          <a
            href="mailto:mert.ozkaya@outlook.com.tr"
            className="contact__social-link"
            aria-label="Email"
          >
            <Mail size={20} />
          </a>
        </div>
      </motion.div>
    </SectionWrapper>
  );
}
